import React, { useContext } from "react";
import stairsImg1 from "@images/services/schody-main.webp";
import stairsImg2 from "@images/services/schody-1.webp";
import stairsImg3 from "@images/services/schody-2.webp";
import { LanguageContext } from '../../../index';

const StairsServiceContent = ({ sTitle }) => {
    const { language } = useContext(LanguageContext);

    return (
        <div className="service-single-wrap">
            <div className="service-single-item">
                <div className="service-single-main-img">
                    <img src={stairsImg1} alt={sTitle} />
                </div>
                <div className="service-single-title">
                    <h3>{sTitle}</h3>
                </div>
                {language === "en" ? (
                    <>
                        <p>
                            Wooden stairs combine functionality, durability, and exceptional aesthetics. Wood as a material for stairs works perfectly in both modern and classic interiors, giving them a warm and cozy character. Wooden stairs are not only practical but also serve as an impressive decorative element of the home.
                        </p>
                        <p>
                            Oak stairs are the most popular, distinguished by their high resistance to abrasion, stability, and beautiful natural grain. Oak stairs are an excellent choice for those who value durability and elegance. Oak wood is perfect for both single-family homes and commercial spaces.
                        </p>
                        <p>
                            Properly designed and crafted wooden stairs can serve for many years, retaining their unique appearance. Thanks to a wide range of finishes and colors, wooden stairs can be perfectly matched to any interior design style. In the Małopolska region, especially in Kraków, wooden stairs are the number one choice among people looking for durable and aesthetic solutions for their homes.
                        </p>
                    </>
                ) : (
                    <>
                        <p>
                            Schody drewniane to połączenie funkcjonalności, trwałości i wyjątkowej estetyki. Drewno jako materiał na schody doskonale sprawdza się zarówno w nowoczesnych, jak i klasycznych wnętrzach, nadając im ciepły i przytulny charakter. Schody wykonane z drewna są nie tylko praktyczne, ale również stanowią efektowny element dekoracyjny domu.
                        </p>
                        <p>
                            Największą popularnością cieszą się schody dębowe, które wyróżniają się wysoką odpornością na ścieranie, stabilnością oraz pięknym, naturalnym usłojeniem. Schody z dębu to doskonały wybór dla osób ceniących sobie trwałość i elegancję. Drewno dębowe świetnie sprawdza się zarówno w domach jednorodzinnych, jak i w przestrzeniach komercyjnych.
                        </p>
                        <p>
                            Odpowiednio zaprojektowane i wykonane schody drewniane mogą służyć przez wiele lat, zachowując swój wyjątkowy wygląd. Dzięki szerokiej gamie wykończeń i kolorów, schody z drewna można idealnie dopasować do każdego stylu aranżacji wnętrza. W regionie Małopolski, a szczególnie w Krakowie, schody drewniane są wyborem numer jeden wśród osób poszukujących trwałych i estetycznych rozwiązań do swojego domu.
                        </p>
                    </>
                )}
                <div className="row mt-4">
                    <div className="col-md-6 col-sm-6 col-12">
                        <div className="p-details-img">
                            <img src={stairsImg2} alt={sTitle + (language === "en" ? " - photo 1" : " - zdjęcie 1")} />
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-6 col-12">
                        <div className="p-details-img">
                            <img src={stairsImg3} alt={sTitle + (language === "en" ? " - photo 2" : " - zdjęcie 2")} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="service-single-item list-widget">
                <div className="service-single-title">
                    <h3>{language === "en" ? "Advantages of wooden stairs" : "Zalety schodów drewnianych"}</h3>
                </div>
                <ul>
                    {language === "en" ? (
                        <>
                            <li>Natural and elegant appearance suitable for any interior</li>
                            <li>High durability and resistance to mechanical damage</li>
                            <li>Possibility of renovation and surface refreshing</li>
                            <li>Pleasure of use thanks to the warm structure of wood</li>
                            <li>Ecological and healthy solution for the home</li>
                        </>
                    ) : (
                        <>
                            <li>Naturalny i elegancki wygląd pasujący do każdego wnętrza</li>
                            <li>Wysoka trwałość i odporność na uszkodzenia mechaniczne</li>
                            <li>Możliwość renowacji i odświeżenia powierzchni</li>
                            <li>Przyjemność użytkowania dzięki ciepłej strukturze drewna</li>
                            <li>Ekologiczne i zdrowe rozwiązanie dla domu</li>
                        </>
                    )}
                </ul>
            </div>
            <div className="service-single-item">
                <div className="service-single-title">
                    <h3>{language === "en" ? "Why choose wooden stairs?" : "Dlaczego warto wybrać schody drewniane?"}</h3>
                </div>
                <p>
                    {language === "en"
                        ? "Wooden stairs are an investment for years. Thanks to their versatility and timeless character, wood never goes out of style. It is friendly for allergy sufferers, easy to keep clean, and perfectly matches various interior styles. By choosing wooden stairs, you emphasize the prestige and uniqueness of your home."
                        : "Schody drewniane to inwestycja na lata. Dzięki swojej uniwersalności i ponadczasowemu charakterowi, drewno nigdy nie wychodzi z mody. Jest przyjazne dla alergików, łatwe w utrzymaniu czystości i doskonale komponuje się z różnymi stylami wnętrzarskimi. Wybierając schody drewniane, podkreślasz prestiż i wyjątkowość swojego domu."
                    }
                </p>
            </div>
            <div className="service-single-item list-widget">
                <div className="service-single-title">
                    <h3>{language === "en" ? "Wooden stairs implementation process" : "Proces realizacji schodów drewnianych"}</h3>
                </div>
                <ul>
                    {language === "en" ? (
                        <>
                            <li>Consulting on the selection of the appropriate wood species and stair design</li>
                            <li>Measurements and construction preparation</li>
                            <li>Precise execution and installation by experienced professionals</li>
                            <li>Finishing and surface protection</li>
                            <li>Instructions on care and maintenance of the stairs</li>
                        </>
                    ) : (
                        <>
                            <li>Doradztwo w wyborze odpowiedniego gatunku drewna i projektu schodów</li>
                            <li>Pomiary i przygotowanie konstrukcji</li>
                            <li>Precyzyjne wykonanie i montaż schodów przez doświadczonych fachowców</li>
                            <li>Wykończenie i zabezpieczenie powierzchni</li>
                            <li>Instruktaż dotyczący pielęgnacji i konserwacji schodów</li>
                        </>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default StairsServiceContent;